var React = require('react');

function Pause (props) {
    return React.createElement("svg",props,React.createElement("g",null,[React.createElement("path",{"d":"M17.991,40.976c0,3.662-2.969,6.631-6.631,6.631l0,0c-3.662,0-6.631-2.969-6.631-6.631V6.631C4.729,2.969,7.698,0,11.36,0l0,0c3.662,0,6.631,2.969,6.631,6.631V40.976z","key":0}),React.createElement("path",{"d":"M42.877,40.976c0,3.662-2.969,6.631-6.631,6.631l0,0c-3.662,0-6.631-2.969-6.631-6.631V6.631C29.616,2.969,32.585,0,36.246,0l0,0c3.662,0,6.631,2.969,6.631,6.631V40.976z","key":1})]));
}

Pause.defaultProps = {"className":"pause-icon","version":"1.1","fill":"#fff","viewBox":"0 0 47.607 47.607"};

module.exports = Pause;

Pause.default = Pause;
